export default {
      id: "bell-filled-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#bell-filled",
      toString: function () {
        return this.url;
      }
    }